export class CategoryDto {
  categoryId: number;
  titleFrancais: string;
  titleAnglais: string;
  pathFolder: string;
  pathImage: string;
  urlImage: string;
  image: string;
  typeCategory: string;
}
